
<template>
  <div class="albums">
    <h3>{{ albumData.title }}</h3>
    <div class="ppoint">
     <div @click="changeSelectedAndRoute(albumData.id)"><img class="album_art" :src=albumData.coverSrc /></div>
     <br />
     {{albumData.release_date}} - {{albumData.publisher}}
    </div>
    <br />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AlbumListItem",
  props: ["albumData"],
  data() {
    return {};
  },
  methods: {
    ...mapActions(["changeSelectedAlbum"]),
    changeSelectedAndRoute(id) {
      this.changeSelectedAlbum(id);
      this.$router.push("album");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.album_art {
  width: 128px;
  height: 128px;
}
.ppoint {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AlbumListItem.vue